import axios from 'axios';

export default axios.create({
  baseURL: `https://realtism.com/magic/api/`,//YOUR_API_URL HERE
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  }
});
